import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface CapacityManagementEstimatedVsActualHoursTeamsPayload
  extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_TEAMS;
    id: string;
    attributes: {
      data: Array<{
        team_id: string;
        team_name: string;
        allocated_hours_in_range: number;
        actual_hours_in_range: number;
      }>;
    };
  };
}

export const parseCapacityManagementEstimatedVsActualHoursTeamsPayload = (
  payload: BaseInsightPayload
): CapacityManagementEstimatedVsActualHoursTeamsPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_TEAMS,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      team_id: string;
      team_name: string;
      allocated_hours_in_range: number;
      actual_hours_in_range: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ESTIMATED_VS_ACTUAL_HOURS_TEAMS,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
